import type { ar } from "./ar";

export const en: Record<keyof typeof ar, string> = {
  appName: "Vira Studio",
  navCreate: "Create",
  navProfile: "Profile",
  navAccount: "Account",
  navLibrary: "Library",
  navAdmin: "Admin",
  login: "Log in",
  signup: "Sign up",
  email: "Email",
  password: "Password",
  displayName: "Display name",
  logout: "Log out",
  noAccount: "No account yet?",
  haveAccount: "Already have an account?",
  forgotPassword: "Forgot your password?",
  resetPassword: "Reset password",
  resetPasswordHint: "Enter your email and we'll send you a link to reset your password.",
  sendResetLink: "Send reset link",
  resetEmailSent: "A password reset link has been sent to your email.",
  backToLogin: "Back to log in",
  newPassword: "New password",
  updatePassword: "Update password",
  passwordUpdated: "Your password has been updated successfully.",
  profileTitle: "Profile & Identity",
  entityContact: "Entity & contact",
  clinicPhone: "Clinic phone number",
  clinicAddress: "Clinic address",
  bio: "Professional bio",
  specialty: "Specialty",
  addSpecialty: "Add specialty",
  scope: "Scope of expertise",
  services: "Services & procedures",
  addTag: "Add",
  focusGeneral: "Go general",
  focusSpecific: "Focus on specific services",
  cohorts: "Target audience",
  addCohort: "Add cohort",
  removeCohort: "Remove",
  ageFrom: "Age from",
  ageTo: "to",
  gender: "Gender",
  male: "Male",
  female: "Female",
  both: "Both",
  complaints: "Complaints / concerns",
  archetypes: "Brand archetypes",
  findArchetypes: "Find my archetypes",
  branding: "Branding",
  logo: "Logo",
  uploadLogo: "Upload logo",
  generateLogo: "Generate logo",
  saveLogo: "Save logo",
  removeLogo: "Remove logo",
  logoArabic: "Arabic",
  logoEnglish: "English",
  referenceDesigns: "Reference designs",
  doctorPhotos: "Doctor photos",
  remove: "Remove",
  canvasAssets: "Canvas assets",
  characterSheet: "Character sheet",
  characterSheetHint: "Used to keep the doctor's facial features correct in AI designs.",
  generateCharacterSheet: "Generate character sheet (2)",
  canvasBackgrounds: "Canvas backgrounds",
  uploadBackground: "Upload background",
  generateBackground: "Generate background (1)",
  backgroundPrompt: "Background description (optional)",
  defaultBackground: "Default",
  selectBackground: "Select background",
  deleteWarnTitle: "Download before deleting",
  deleteWarnBody: "Download this image before deleting — it can't be recovered.",
  downloadDelete: "Download & Delete",
  deleteAnyway: "Delete anyway",
  cancel: "Cancel",
  account: "Account",
  subscription: "Subscription",
  creditsRemaining: "Credits remaining",
  subscribe: "Subscribe to start",
  planMonthly: "Monthly",
  planQuarterly: "Quarterly",
  perMonth: "/ month",
  selectPlan: "Select plan",
  instapayInstructions: "InstaPay payment instructions",
  uploadProof: "Upload payment proof",
  proofUploaded: "Proof uploaded — awaiting activation",
  createTitle: "Create content",
  topic: "Topic / what to post about",
  language: "Language",
  arabic: "Arabic",
  english: "English",
  targetCohort: "Target cohort",
  allCohorts: "All cohorts",
  headline: "Headline",
  addDoctorImage: "Add doctor image",
  addPhone: "Add phone number",
  addLogo: "Add logo",
  generateCaption: "Generate caption",
  freeCanvas: "Free (Canvas)",
  aiDesign: "AI Design",
  credits2: "(2 credits)",
  download: "Download",
  saveToLibrary: "Save to library",
  requestEdit: "Request edit",
  retryFree: "Retry — Free",
  subscribeToCreate: "Subscribe to start creating",
  save: "Save",
  saving: "Saving…",
  saved: "Saved",
  loading: "Loading…",
  generating: "Generating…",
  error: "Something went wrong",
};
